import React from 'react';
import { Clock, RefreshCw, Image } from 'lucide-react';

const PhotoThumbnailSection = ({
  result,
  isSelected,
  onToggleSelection,
  disableSelection
}) => {
  const fallbackImage =
    'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHZpZXdCb3g9IjAgMCA5NiA5NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2IiBmaWxsPSIjRjNGNEY2Ii8+CjxwYXRoIGQ9Ik0zOSAzMkw0OCA0MEw1NyAzMkw2NiA0MEw3NSAzMlY2NEgyMVYzMkgzOVoiIGZpbGw9IiNEMUQ1REIiLz4KPGNpcmNsZSBjeD0iMzQiIGN5PSI0MCIgcj0iNSIgZmlsbD0iI0QxRDVEQiIvPgo8L3N2Zz4=';

  const imageSource = result.urlSmall || result.urlMedium || result.urlLarge;
  const showSelection = result.status === 'processed' && !result.applied;

  return (
    <div className="relative flex-shrink-0">
      {imageSource ? (
        <img
          src={imageSource}
          alt={result.generatedTitle || result.originalTitle || 'Photo'}
          className="w-24 h-24 rounded-lg object-cover border border-gray-200"
          onError={(event) => {
            // eslint-disable-next-line no-param-reassign
            event.target.src = fallbackImage;
          }}
        />
      ) : (
        <div className="w-24 h-24 bg-gray-100 rounded-lg flex items-center justify-center border border-gray-200">
          <Image className="h-8 w-8 text-gray-400" />
        </div>
      )}

      {showSelection && (
        <div className="absolute -top-2 -left-2">
          <input
            type="checkbox"
            checked={isSelected}
            onChange={onToggleSelection}
            disabled={disableSelection}
            className="h-5 w-5 text-blue-600 bg-white border-2 border-gray-300 rounded shadow-sm focus:ring-blue-500 disabled:opacity-50"
          />
        </div>
      )}

      {result.status === 'pending' && (
        <div className="absolute inset-0 bg-blue-600 bg-opacity-10 rounded-lg flex items-center justify-center">
          <Clock className="h-4 w-4 text-blue-600 animate-pulse" />
        </div>
      )}

      {result.status === 'retry_pending' && (
        <div className="absolute inset-0 bg-orange-600 bg-opacity-10 rounded-lg flex items-center justify-center">
          <RefreshCw className="h-4 w-4 text-orange-600 animate-spin" />
        </div>
      )}
    </div>
  );
};

export default PhotoThumbnailSection;
